/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { GetLoadingLocationsResponseJson } from './get-loading-locations-response-json';
import { GetLoadingLocationsResult } from '../results/get-loading-locations-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { LoadingLocationDto } from '../models/loading-location-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
//</custom-head>

export class GetLoadingLocationsResponse extends ResponseWithErrorGeneric<GetLoadingLocationsResponseJson, GetLoadingLocationsResult> implements IResponseWithErrorGeneric<GetLoadingLocationsResult> {
  public loadingLocations: LoadingLocationDto[];

  //<custom-body>
  constructor(response: HttpResponse<GetLoadingLocationsResponse>) {
    super(response, GetLoadingLocationsResult.Error);
    if (this.result !== GetLoadingLocationsResult.Success) {
      return;
    }

    if (this.body.loadingLocations != null)
      this.loadingLocations = this.body.loadingLocations;
  }
  //</custom-body>
}
